import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import DisputeManagement from '../../../components/siteadmin/DisputeManagement';
import NotFound from '../../notFound/NotFound';
import { restrictUrls } from '../../../helpers/adminPrivileges';
import messages from '../../../locale/jsonMessages';

// Dispute screen attached to a reservation (R15): details, caution, photos, statements and the administrator decision.
export default async function action({ store, params, intl }) {
  const title = intl?.formatMessage(messages.inspAdmDisputeTitle);
  const reservationId = Number(params?.reservationId);

  // From Redux Store
  let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  let adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
  let privileges = store.getState().listSettings && store.getState().listSettings.privileges;

  if (!isAdminAuthenticated) {
    return { redirect: '/siteadmin/login' };
  }

  // Same privilege as "Manage reservations": the dispute is part of the reservation (no independent module, R13).
  if (!restrictUrls('/siteadmin/reservations', adminPrivileges, privileges)) {
    return { redirect: '/siteadmin' };
  }

  if (!Number.isInteger(reservationId) || reservationId <= 0) {
    return { title, component: <AdminLayout><NotFound title={title} /></AdminLayout>, status: 404 };
  }

  return {
    title,
    component: <AdminLayout><DisputeManagement reservationId={reservationId} /></AdminLayout>,
  };
};
